// @flow
import React from 'react';

import { FormattedMessage } from 'translations';
import Tooltip from 'mz-ui-kit/core/Tooltip';
import CheckboxField from 'mz-ui-kit/form/CheckboxField';
import config from 'config';

import { MeetAndGreet, Inline, StrongMessage, BlackLabel } from './elements';

const messages = {
  meetAndGreet: { id: 'SEARCH_RESULTS.AMENITIES.MEET_AND_GREET' },
  showOptionsIncluded: { id: 'SEARCH_RESULTS.SHOW_MEET_AND_GREET_INCLUDED' },
  showOptions: { id: 'SEARCH_RESULTS.SHOW_MEET_AND_GREET' },
  hint: { id: 'SEARCH_RESULTS.MEET_AND_GREET_HINT' }
};

type Props = {
  onChange: (param: boolean) => void,
  value: boolean
}

/**
 * Filter Meet and Greet, checkbox used to filter searches by meet & greet
 * @param {Function} onChange
 * @param {Boolean} value
 * @return React.Node
 */
export default function FilterMeetAndGreet ({ onChange, value, mngIncluded }: Props) {
  if (!config.SHOW_MEET_AND_GREET_FILTER) return null;
  const filterMessage = mngIncluded ? messages.showOptionsIncluded : messages.showOptions

  const renderMeetAndGreet = (innerRef = null, targetProps = {}) => {
    return (
      <MeetAndGreet ref={innerRef} {...targetProps}>
        <FormattedMessage {...messages.meetAndGreet} />
      </MeetAndGreet>);
  }

  const renderTooltip = () => {
    return (
      <Inline>
        <Tooltip
          placement="bottom"
          width="200px"
          target={renderMeetAndGreet}
          content={() => (
            <span>
              <StrongMessage><FormattedMessage {...messages.meetAndGreet} /></StrongMessage>
              <FormattedMessage {...messages.hint} />
            </span>
          )}
        />
      </Inline>
    );
  }

  return (
    <CheckboxField
      input={{
        onChange,
        value
      }}
      label={(
        <BlackLabel>
          <FormattedMessage
            {...filterMessage}
            values={{
              meetAndGreetTooltip: renderTooltip()
            }}
          />
        </BlackLabel>
      )}
    />
  );
}
